/* BlastBlocks — photo réelle qui tombe en briques et s'assemble (header) ou se construit au scroll. */
(function () {
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function say(status, t) {
    if (!status || !t) return;
    status.textContent = t;
    status.classList.remove('pr-pop'); void status.offsetWidth; status.classList.add('pr-pop');
  }

  function setup(el) {
    if (el.__pr) return; el.__pr = true;
    var src = el.getAttribute('data-src'); if (!src) return;
    var labels = []; try { labels = JSON.parse(el.getAttribute('data-labels') || '[]'); } catch (e) {}
    var status = el.parentNode.querySelector('.h3-status');
    var img = new Image();
    img.onload = function () { build(el, img, src, labels, status); };
    img.src = src;
  }

  function build(el, img, src, labels, status) {
    var mode = el.getAttribute('data-mode') || 'intro';
    var w = img.naturalWidth, h = img.naturalHeight;
    var box = document.createElement('div'); box.className = 'pr-box';
    var full = document.createElement('img'); full.className = 'pr-full'; full.src = src; full.alt = ''; box.appendChild(full);
    var cols = innerWidth < 700 ? 9 : 13, rows = Math.max(4, Math.round(cols * h / w));
    var ok = [], i, r, c;
    try {
      var cv = document.createElement('canvas'); cv.width = cols * 6; cv.height = rows * 6;
      var cx = cv.getContext('2d'); cx.drawImage(img, 0, 0, cv.width, cv.height);
      var d = cx.getImageData(0, 0, cv.width, cv.height).data;
      for (r = 0; r < rows; r++) for (c = 0; c < cols; c++) {
        var a = 0; for (var y = 0; y < 6; y++) for (var x = 0; x < 6; x++) a += d[((r * 6 + y) * cv.width + (c * 6 + x)) * 4 + 3];
        ok.push(a / 36 > 12);
      }
    } catch (e) { for (i = 0; i < rows * cols; i++) ok.push(true); }
    var tiles = [];
    for (r = 0; r < rows; r++) for (c = 0; c < cols; c++) {
      if (!ok[r * cols + c]) continue;
      var t = document.createElement('i'); t.className = 'pr-tile';
      t.style.cssText = 'left:' + (c * 100 / cols) + '%;top:' + (r * 100 / rows) + '%;width:' + (100 / cols + 0.06) + '%;height:' + (100 / rows + 0.06) + '%;' +
        'background-image:url("' + src + '");background-size:' + (cols * 100) + '% ' + (rows * 100) + '%;' +
        'background-position:' + (cols > 1 ? c * 100 / (cols - 1) : 0) + '% ' + (rows > 1 ? r * 100 / (rows - 1) : 0) + '%';
      t._r = r; t._rot = Math.random() * 60 - 30; t._dx = Math.random() * 30 - 15; t._delay = (rows - 1 - r) * 70 + Math.random() * 260;
      box.appendChild(t); tiles.push(t);
    }
    el.appendChild(box); el.classList.add('pr-ready');
    function fit() {
      var W = el.clientWidth * 0.92, H = el.clientHeight * 0.9, s = Math.min(W / w, H / h);
      box.style.width = (w * s) + 'px'; box.style.height = (h * s) + 'px';
    }
    fit(); addEventListener('resize', fit);
    if (RM) { box.classList.add('is-built'); say(status, labels[labels.length - 1]); return; }
    if (mode === 'scrub') scrub(el, box, tiles, rows, labels, status); else intro(el, box, tiles, labels, status);
  }

  function rain(box, tiles, cb) {
    box.classList.remove('is-built');
    tiles.forEach(function (t) { t.style.transition = 'none'; t.style.transform = 'translate(' + t._dx + 'vw,-' + (70 + Math.random() * 50) + 'vh) rotate(' + t._rot + 'deg)'; t.style.opacity = '0'; });
    void box.offsetWidth;
    var max = 0;
    tiles.forEach(function (t) {
      max = Math.max(max, t._delay);
      t.style.transition = 'transform .75s cubic-bezier(.3,1.35,.5,1) ' + t._delay + 'ms, opacity .15s linear ' + t._delay + 'ms';
      t.style.transform = 'none'; t.style.opacity = '1';
    });
    setTimeout(function () { box.classList.add('is-built'); if (cb) cb(); }, max + 850);
  }

  function intro(el, box, tiles, labels, status) {
    var mz = (el.getAttribute('data-muzzle') || '').split(',').map(Number), busy = false, timers = [];
    function later(f, ms) { timers.push(setTimeout(f, ms)); }
    function fire() {
      if (busy || !box.classList.contains('is-built')) return; busy = true; say(status, labels[2]);
      box.classList.remove('pr-recoil'); void box.offsetWidth; box.classList.add('pr-recoil');
      if (mz.length === 4 && !isNaN(mz[0])) {
        var dt = document.createElement('i'); dt.className = 'pr-dart';
        dt.style.left = (mz[0] * 100) + '%'; dt.style.top = (mz[1] * 100) + '%';
        dt.style.setProperty('--a', (Math.atan2(mz[3], mz[2]) * 180 / Math.PI) + 'deg');
        dt.style.setProperty('--tx', (mz[2] * 90) + 'vmax'); dt.style.setProperty('--ty', (mz[3] * 90) + 'vmax');
        box.appendChild(dt); setTimeout(function () { dt.remove(); }, 1000);
      }
      var pt = (el.getAttribute('data-port') || '').split(',').map(Number);
      if (pt.length === 2 && !isNaN(pt[0])) {
        var sh = document.createElement('i'); sh.className = 'pr-shell';
        sh.style.left = (pt[0] * 100) + '%'; sh.style.top = (pt[1] * 100) + '%';
        box.appendChild(sh); setTimeout(function () { sh.remove(); }, 1000);
      }
      setTimeout(function () { busy = false; }, 240);
    }
    function explode() {
      box.classList.remove('is-built');
      tiles.forEach(function (t) {
        t.style.transition = 'transform .6s cubic-bezier(.5,0,.8,.4), opacity .45s linear';
        t.style.transform = 'translate(' + (t._dx * 1.6) + 'vw,-' + (80 + Math.random() * 40) + 'vh) rotate(' + (t._rot * 3) + 'deg)'; t.style.opacity = '0';
      });
      later(cycle, 900);
    }
    function cycle() {
      say(status, labels[0]);
      rain(box, tiles, function () {
        later(function () { say(status, labels[1]); box.classList.remove('pr-rack'); void box.offsetWidth; box.classList.add('pr-rack'); }, 300);
        for (var k = 0; k < 6; k++) later(fire, 1500 + k * 300);
        later(function () { say(status, labels[3]); }, 3500);
        later(function () { say(status, labels[4]); explode(); }, 7000);
      });
    }
    el.addEventListener('click', fire);
    if (el.getAttribute('data-follow') === 'true' && matchMedia('(pointer:fine)').matches) {
      (el.closest('section') || document).addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        box.style.setProperty('--ry', (x * 14) + 'deg'); box.style.setProperty('--rx', (-y * 10) + 'deg');
      });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); cycle(); } }, { threshold: 0.2 });
      io.observe(el);
    } else cycle();
  }

  function scrub(el, box, tiles, rows, labels, status) {
    tiles.forEach(function (t) { t._th = ((rows - 1 - t._r) / rows) * 0.6 + Math.random() * 0.15; t._oy = -(40 + Math.random() * 50); });
    var last = -1, cur = '';
    function upd() {
      var r = el.getBoundingClientRect(), vh = innerHeight;
      var p = (vh - r.top) / (vh + r.height * 0.4); p = Math.max(0, Math.min(1, p * 1.25));
      if (Math.abs(p - last) < 0.002) return; last = p;
      tiles.forEach(function (t) {
        var k = Math.max(0, Math.min(1, (p - t._th) / 0.22)), e = 1 - Math.pow(1 - k, 3);
        t.style.transform = 'translate(' + (t._dx * (1 - e)) + 'vw,' + (t._oy * (1 - e)) + 'vh) rotate(' + (t._rot * (1 - e)) + 'deg)';
        t.style.opacity = k > 0 ? '1' : '0';
      });
      var done = p >= 0.97; box.classList.toggle('is-built', done);
      var lbl = done ? labels[1] : labels[0]; if (lbl && lbl !== cur) { cur = lbl; say(status, lbl); }
    }
    addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd); upd();
  }

  function all() { document.querySelectorAll('[data-photo-rain]').forEach(setup); }
  if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
  document.addEventListener('shopify:section:load', all);
})();
